import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tarde',
  templateUrl: './tarde.component.html',
  styleUrls: ['./tarde.component.scss']
})
export class TardeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
